import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, Validators, FormBuilder, ValidatorFn } from '@angular/forms';
import { TravelerDetailComponent, TravelerDetailViewConfig } from '@bhtp-client-web/component';

@Component({
    selector: 'additional-traveler-detail',
    template: require('./additional-traveler-detail.component.html')
})
export class AdditionalTravelerDetailComponent extends TravelerDetailComponent implements OnChanges {
    @Input() public configuration: TravelerDetailViewConfig;

    constructor(fb: FormBuilder) {
        super(fb);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (this.form && this.traveler && this.configuration && !this.formInitialized) {
            this.buildForm();
        }
    }

    protected buildForm(): void {
        this.buildFirstNameControl();
        this.buildLastNameControl();
        this.buildAgeControl();
        this.buildBirthDateControl();
        this.buildGenderControl();
        this.buildTripCostControl();
        this.buildEmailControl();
        this.setUpValidationMessages();
        this.formInitialized = true;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/policy-edit/traveler/additional-traveler-detail.component.ts